import { Platform } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';
const useIsTablet = () => {
    const { width } = useSafeAreaFrame();
    return ((Platform.OS === 'android' && width >= 600) ||
        (Platform.OS === 'ios' && Platform.isPad && width > 585));
};
export default useIsTablet;
